module.exports = __webpack_public_path__ + "static/media/46.3214c548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/46.jpg
// module id = 415
// module chunks = 0